import script from "./UiHeading.vue?vue&type=script&setup=true&lang=ts"
export * from "./UiHeading.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__